import firebase from "firebase/app";
import "firebase/firestore";

export interface PromotionInterface {
    promotionCode: string,
    createdAt: Date,
    createdBy: string,
    isSelected: boolean,
    value: number,
    isUsed: boolean,
    
    /**
     * Taked
     */
    takedAt?: Date | firebase.firestore.Timestamp,
    takedName?: string,
    
}

class PromotionsService {

    #_fr = firebase.firestore();

    async getPromotions() {
        return await this.#_fr
        .collection("promotions")
        .orderBy("createdAt", "desc")
        .get();
    }

    async createPromotion(params: PromotionInterface): Promise<string> {
        await this.#_fr.collection("promotions").doc(params.promotionCode).set(params);
        return params.promotionCode;
    }

    async deletePromotion(promotionCode: string) {
        return await this.#_fr.collection("promotions").doc(promotionCode).delete();
    }
}

export default PromotionsService;